/**
 * aswbe authorization eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ANA BizログインAPIリクエストデータ型
 */
export interface AuthorizationRequest {
  /**
   * 接続区分
   */
  connectionType?: AuthorizationRequest.ConnectionTypeEnum;
  /**
   * 企業IDまたは組織ID
   */
  companyOrOrganizationCode?: string;
  /**
   * 企業用パスワード
   */
  companyPassword?: string;
  /**
   * 管理者ID
   */
  adminUserId?: string;
  /**
   * 企業ID保存有無
   */
  saveCompanyOrOrganizationCode?: boolean;
  /**
   * パスワード保存有無
   */
  saveCompanyPassword?: boolean;
  /**
   * AMC会員番号
   */
  amcNumber?: string;
  /**
   * AMC用パスワード
   */
  amcPassword?: string;
  /**
   * AMC自動ログインフラグ
   */
  amcPersistent?: boolean;
  /**
   * 企業用管理コード1
   */
  companyManagementCd1?: string;
  /**
   * 企業用管理コード2
   */
  companyManagementCd2?: string;
  /**
   * 企業用管理コード3
   */
  companyManagementCd3?: string;
  /**
   * 企業用管理コード4
   */
  companyManagementCd4?: string;
  /**
   * 搭乗予定日(往路)
   */
  dateFlight1?: string;
  /**
   * 搭乗予定日(復路)
   */
  dateFlight2?: string;
  /**
   * データ連携送信フラグ
   */
  sendDataFlg?: string;
  /**
   * データ連携送信先URL
   */
  sendDataUrl?: string;
  /**
   * データ連携送信形式
   */
  sendDataType?: string;
}
export namespace AuthorizationRequest {
  export type ConnectionTypeEnum = 'normal' | 'seamless';
  export const ConnectionTypeEnum = {
    Normal: 'normal' as ConnectionTypeEnum,
    Seamless: 'seamless' as ConnectionTypeEnum,
  };
}
